import { Component, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { MenuService } from '../services/menu.service';
import { environment } from '../../environments/environment';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false,
})
export class HeaderComponent {
    auth = inject(AuthService);
    private menuService = inject(MenuService);

    authenticated$: Observable<boolean>;

    constructor() {
        this.authenticated$ = this.auth.csrfToken$.pipe(
            delay(10),
            map((token) => {
                return !!token;
            }),
        );
    }

    menuClick() {
        this.menuService.toggle();
    }

    protected readonly environment = environment;
}
